import { DateTime } from 'luxon'
import { SubscriptionDataDto } from './subscription-data.dto'
import { SubscriptionData } from './subscription-data.model'

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace SubscriptionDataDtoConverter {
  export function toSubscriptionData(
    data: SubscriptionDataDto,
  ): SubscriptionData {
    return {
      allowedStudentCount: data.allowedStudentCount,
      currentStudentCount: data.currentStudentCount,
      allowedWorkbookCount: data.allowedWorkbookCount,
      currentWorkbookCount: data.currentWorkbookCount,
      renewalDate: data.renewalDate
        ? DateTime.fromISO(data.renewalDate).toJSDate()
        : undefined,
    }
  }
}
